import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidebarState {
  // The IGNTR redesign expects the primary nav section to be expanded by
  // default — matching the handoff sidebar where `open.main` starts true.
  // Other groups stay collapsed so the rail doesn't overflow.
  isMainOpen = true;
  isCrmOpen = false;
  isIgniteOpen = false;
  isAdminOpen = false;
  isCrmAdminOpen = false;
  isAiAssistantOpen = false;
  isLobbyOpen = false;
  isReception = false;

  /**
   * Live search query for the sidebar nav. The <input> in the sidebar
   * header writes here; SidebarItemsComponent reads it to filter the
   * rendered nav rows.
   */
  searchQuery = '';
}
